import { Form } from 'react-bootstrap';
import ThInputText from '../../forms/th-input-text';
import Button from '../../UI/button';
import { Link } from 'react-router-dom';

type Props = {};
const ChangeYourPasswordPage = (props: Props) => {
  return (
    <Form className='change-your-password'>
      <h6 style={{ marginBottom: '16px' }}>Change the Password</h6>
      <ThInputText
        label='Current Password'
        value={' '}
      />
      <ThInputText
        label='New Password'
        value={' '}
      />
      <ThInputText
        mb={0}
        label='Confirm New Password'
        value={' '}
      />
      <Link
        to='/app/settings/forgot-password'
        className='forgot-your-password-link'
      >
        Forgot password?
      </Link>
      <div
        className='d-flex justify-content-end'
        style={{ marginTop: '32px' }}
      >
        <Button
          variant='primary'
          px={30}
        >
          Change
        </Button>
      </div>
    </Form>
  );
};
export default ChangeYourPasswordPage;
